/**
 * Where each tenant's landing page is read from.
 *
 * The ERP served every landing page. A partner whose programme has moved to
 * the ICP reads the ICP's public landing endpoints instead, which answer in
 * the same JSON shape. A tenant moves by adding its subdomain to
 * ICP_TENANTS (one line, one deploy; removing it moves it back).
 *
 * `?source=icp` or `?source=erp` previews either source on any host, the
 * way `?subdomain=` previews any tenant.
 */
export type Source = 'erp' | 'icp';

/** Tenants the ICP serves. ce4how since 15 Oct 2026, after 18 clean nightly
 *  comparisons with the ERP's page; the ERP refuses edits to it
 *  (stakeholders/views/landing_page_views.py EDITED_ON_ICP). */
export const ICP_TENANTS: readonly string[] = ['ce4how'];

const ERP_API = import.meta.env.VITE_API_URL || 'http://localhost:8000';
const ICP_API = import.meta.env.VITE_ICP_API_URL || 'https://icp-backend.m-taka.co.ke';
const DASHBOARD_URL = import.meta.env.VITE_DASHBOARD_URL || 'http://localhost:5174';

export function sourceFor(subdomain: string): Source {
  const asked = new URLSearchParams(window.location.search).get('source');
  if (asked === 'icp' || asked === 'erp') return asked;
  return ICP_TENANTS.includes(subdomain) ? 'icp' : 'erp';
}

/** The tenant's landing endpoint, without a trailing slash. */
export function landingBase(subdomain: string): string {
  return sourceFor(subdomain) === 'icp'
    ? `${ICP_API}/api/v1/public/landing/${subdomain}`
    : `${ERP_API}/stakeholders/landing-page/subdomain/${subdomain}`;
}

/** Where "explore the data" leads: the page's own dashboard when it names
 *  one (an ICP programme), else the partner dashboard. */
export function dashboardUrl(fromPage?: string | null): string {
  return fromPage || DASHBOARD_URL;
}
